export const API_BASE_URL = 'https://wizeline-academy.cdn.prismic.io/api/v2';